import React, { useState, useEffect, Suspense, lazy } from 'react'
import { ImageCarousel } from 'components/image'
import { EventOverviewCard } from 'components/Cards/event'

import { MainNavbar, MainNavbarResponsive } from 'components/NavbarAndTabs'
import { Slider, Select } from 'antd'
import { getAllCategories } from '../../../apis/events'
import { capitalize } from '../../../shared/textFormats'
import { getEventTags, getEventsForHomeBanner } from '../../../apis/home'
import { relationshipStatusOptions } from 'utils/constant/user/profileInfo'
import { getEventLocations, getFilteredEvents } from '../../../apis/eventFilter'
import { convert24To12Hour, formatDate } from '../../../shared/dates'
import { Link } from 'react-router-dom'
import { decodeFromBase64 } from '../../../utils/encodeDecode'

const EmptyEvents = lazy(() => import('components/Cards/emptyCards').then(module => ({ default: module.EmptyEvents })));
const Footer = lazy(() => import("components/Footer/main/index"))
const ResponsiveFooter = lazy(() => import("components/Footer/main/responsive"))

function Index() {

    const { Option } = Select
    const urlParams = new URLSearchParams(window.location.search);

    const [bannerData, setBannerData] = useState()

    const [events, setEvents] = useState([])
    const [pagination, setPagination] = useState({
        current_page: 1,
        next_page: null,
    })
    const [options, setOptions] = useState({
        categories: null,
        tags: null,
        city: null,
        relationship_status: relationshipStatusOptions,
    })
    const [selected, setSelected] = useState({
        search: '',
        categories: [],
        tags: [],
        date: "",
        time: "",
        mode: [],
        city: "",
        relationship_status: [],
        price_from: '',
        price_to: '',
    })


    const [showDatePicker, setShowDatePicker] = useState(false);


    const fetchAllCategory = async () => {
        const res = await getAllCategories()
        setOptions(prev => ({ ...prev, categories: res }))
    }
    const fetchAllTags = async () => {
        const res = await getEventTags()
        setOptions(prev => ({ ...prev, tags: res?.data }))
    }
    const fetchAllEventcity = async () => {
        const res = await getEventLocations()
        setOptions(prev => ({ ...prev, city: res?.data }))
    }

    const updateSelected = (key, value) => {
        setSelected(prevState => {
            if (Array.isArray(prevState[key])) {
                const arr = prevState[key];
                const index = arr.indexOf(value);
                if (index > -1) {
                    return {
                        ...prevState,
                        [key]: arr.filter((_, i) => i !== index)
                    };
                } else {
                    return {
                        ...prevState,
                        [key]: [...arr, value]
                    };
                }
            } else {
                return {
                    ...prevState,
                    [key]: value
                };
            }
        });
    };

    const handleSubmit = async () => {
        const page = pagination.next_page ? pagination.next_page : 1;
        const res = await getFilteredEvents(page, selected);
        if (pagination.next_page) {
            setEvents(prev => ([...prev, ...res?.data]));
        } else {
            setEvents(res?.data);
        }

        setPagination(({ next_page: res?.pagination.next_page, current_page: res?.pagination.current_page }));
    }

    const isStateEmpty = () => {
        return (
            selected.search === '' &&
            selected.categories.length === 0 &&
            selected.tags.length === 0 &&
            selected.date === '' &&
            selected.time === '' &&
            selected.mode.length === 0 &&
            selected.city === '' &&
            selected.relationship_status.length === 0 &&
            selected.price_from === '' &&
            selected.price_to === ''
        );
    };

    useEffect(() => {
        if (isStateEmpty()) {
            handleSubmit();
        }
    }, []);


    const sliderStyle = {
        trackStyle: {
            backgroundColor: 'red',
        },
        dotStyle: {
            borderColor: 'red',
            backgroundColor: 'red',
        },
        railStyle: {
            backgroundColor: 'pink',
        },
    };

    const fetchBannerEvents = async () => {
        const res = await getEventsForHomeBanner()
        setBannerData(res?.data)
    }


    useEffect(() => {
        fetchAllCategory()
        fetchAllTags()
        fetchBannerEvents()
        fetchAllEventcity()
    }, [])

    useEffect(() => {
        const categoryId = decodeFromBase64(urlParams.get("categoryId"));
        const searchQuery = decodeFromBase64(urlParams.get("search"));
        const cityQuery = decodeFromBase64(urlParams.get("city"));
        let shouldSubmit = false;

        if (categoryId) {
            updateSelected('categories', categoryId);
            shouldSubmit = true;
        }

        if (searchQuery) {
            updateSelected('search', searchQuery);
            shouldSubmit = true;
        }
        if (cityQuery) {
            updateSelected('city', cityQuery);
            shouldSubmit = true;
        }

        if (shouldSubmit) {
            setShouldSubmit(true);
        }

    }, []);

    const [shouldSubmit, setShouldSubmit] = useState(false);

    useEffect(() => {
        if (shouldSubmit) {
            const timer = setTimeout(() => {
                handleSubmit();
                setShouldSubmit(false);
            }, 1000);

            return () => clearTimeout(timer);
        }
    }, [selected, shouldSubmit]);

    return (
        <div className="flex flex-col h-full">
            {/* Navbar */}
            <div className="text-white h-18">
                <div className="hidden lg:block">
                    <MainNavbar isEventFilterPage={true} handleOnChange={updateSelected} />
                </div>
                <div className="block lg:hidden">
                    <MainNavbarResponsive isEventFilterPage={true} handleOnChange={updateSelected} />
                </div>
            </div>

            {/* Image Carousel */}
            <div className="flex flex-col items-center w-full mt-5">
                <div className='w-10/12 mt-3'>
                    {bannerData &&
                        <ImageCarousel assets={bannerData} />
                    }
                </div>
            </div>

            <div className="flex items-center justify-center w-full mt-5">
                <div className="flex w-10/12 ">
                    {/* filter */}
                    <div className="min-w-[300px] max-w-[300px] text-black mb-20 pb-20 p-2 border-2 rounded-lg me-2 hidden md:block">
                        <h1 className='text-2xl font-semibold mb-7'>Filter</h1>
                        <div>
                            <p className='font-[600]'>Categories</p>
                            <div className="flex flex-wrap gap-2 mt-3">
                                {options.categories?.map((item) => (
                                    <div className={`p-1 px-3 text-[14px] w-fit rounded-full border cursor-pointer ${selected.categories.includes(item.id) ? 'bg-brandRed text-white' : 'border-gray-500'}`}
                                        onClick={() => updateSelected("categories", item.id)}
                                    >{capitalize(item.name)}</div>
                                ))}
                            </div>
                        </div>
                        <div className='my-7'>
                            <p className='font-[600]'>Tags</p>
                            <div className="flex flex-wrap gap-2 mt-3">
                                {options.tags?.map((item) => (
                                    <div className={`p-1 px-3 text-[14px] w-fit rounded-full border cursor-pointer ${selected.tags.includes(item.id) ? 'bg-brandRed text-white' : 'border-gray-500'}`}
                                        onClick={() => updateSelected("tags", item.id)}
                                    >{capitalize(item.name)}</div>
                                ))}
                            </div>
                        </div>
                        <div className='my-7'>
                            <p className='font-[600]'>Relationship Status</p>
                            <div className="flex flex-wrap gap-2 mt-3">
                                {options.relationship_status?.map((item) => (
                                    <div className={`p-1 px-3 text-[14px] w-fit rounded-full border cursor-pointer ${selected.relationship_status.includes(item.value) ? 'bg-brandRed text-white' : 'border-gray-500'}`}
                                        onClick={() => updateSelected("relationship_status", item.value)}
                                    >{capitalize(item.label)}</div>
                                ))}
                            </div>
                        </div>
                        <div className='my-7'>
                            <p className='font-[600]'>Time & Date</p>
                            <div className="flex w-11/12 p-3 border border-gray-300 mt-7" onClick={() => setShowDatePicker(!showDatePicker)}>
                                <button>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path opacity="0.4" fill-rule="evenodd" clip-rule="evenodd" d="M7.92853 3.6968H16.1188V1.98047H7.92853V3.6968ZM6.06621 2.04688V2.05542C5.42686 2.10775 4.79438 2.22203 4.17905 2.39399V2.38758C4.16076 2.3945 4.14354 2.39983 4.12701 2.40494C4.10531 2.41166 4.08481 2.418 4.06468 2.42709C4.0155 2.43778 3.96746 2.4538 3.92172 2.47409C3.78676 2.51361 3.6518 2.5606 3.52484 2.60866C3.4911 2.62041 3.45736 2.63403 3.42363 2.64764L3.42362 2.64764C3.38988 2.66126 3.35614 2.67488 3.3224 2.68663C3.27608 2.70639 3.22776 2.72801 3.17944 2.74964C3.13111 2.77127 3.08279 2.7929 3.03647 2.81265L2.80772 2.93121C2.76543 2.95062 2.72628 2.97339 2.68633 2.99662L2.68633 2.99662C2.66254 3.01046 2.63848 3.02446 2.61329 3.03801C2.26903 3.23773 1.94993 3.47163 1.66171 3.73757L1.64455 3.75359C1.6067 3.79331 1.56901 3.83184 1.53183 3.86985L1.53182 3.86986L1.53181 3.86987C1.46901 3.93407 1.40766 3.99679 1.34947 4.06119L1.33232 4.07614C0.396747 5.23816 -0.0721809 6.67039 0.00902376 8.12185V8.58217H1.85614V8.11758C1.85614 6.09472 2.57212 4.83551 4.16533 4.19042C4.77379 3.95865 5.41657 3.81554 6.07078 3.7632H6.08794V2.05435L6.06621 2.04688ZM22.6631 4.06222L22.6711 4.07718C23.6056 5.24026 24.0722 6.67356 23.9899 8.12502V8.58962H22.1439V8.11327C22.1828 7.25671 21.9918 6.40442 21.5869 5.63437C21.198 4.97539 20.5758 4.4638 19.8244 4.18612C19.2262 3.95435 18.5926 3.81017 17.9464 3.7589V2.05859C18.5857 2.112 19.2182 2.22521 19.8347 2.39716V2.38862C19.8693 2.40276 19.8958 2.41117 19.9411 2.4256L19.9491 2.42813C19.9701 2.43483 19.9898 2.44153 20.0092 2.44815C20.0362 2.45737 20.0628 2.46643 20.092 2.47513C20.2185 2.51247 20.3368 2.55648 20.4584 2.60177L20.4798 2.6097C20.5359 2.62745 20.5888 2.64947 20.6365 2.6693C20.6519 2.67572 20.6668 2.68192 20.6811 2.68767C20.7817 2.72718 20.8846 2.77418 20.967 2.81369C21.0219 2.83934 21.0754 2.86679 21.1256 2.89253C21.1527 2.90645 21.1788 2.91988 21.2037 2.93224C21.2447 2.95261 21.2803 2.97441 21.3146 2.99536C21.3396 3.01067 21.3639 3.02552 21.389 3.03905C21.7344 3.23984 22.057 3.47481 22.3486 3.73861L22.3589 3.75463C22.4664 3.85182 22.5682 3.95435 22.6631 4.06222Z" fill="#F83758" />
                                        <path d="M18.0001 0.860348V4.64234C18.0001 5.11886 17.5705 5.50482 17.0401 5.50482C16.5097 5.50482 16.0801 5.11886 16.0801 4.64234V0.868972C16.0753 0.39245 16.5025 0.00325466 17.0329 2.03489e-05C17.5633 -0.00321396 17.9965 0.379513 18.0001 0.856035V0.860348Z" fill="#F83758" />
                                        <path d="M7.92 0.873364V4.646C7.92 5.12459 7.48988 5.51263 6.9594 5.51263C6.42892 5.51263 6 5.12459 6 4.646V0.873364C6 0.394778 6.42892 0.0078125 6.9594 0.0078125C7.48988 0.0078125 7.92 0.394778 7.92 0.873364Z" fill="#F83758" />
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 17.8914V8.58594H24V17.8914C24 21.9493 21.4821 23.9994 16.4921 23.9994H7.49642C2.51788 23.9994 0 21.9493 0 17.8914ZM5.41524 13.757C5.41524 14.32 5.90737 14.7767 6.51395 14.7767C7.13198 14.7767 7.62411 14.3093 7.61267 13.7463C7.61267 13.1833 7.12054 12.7266 6.5254 12.7266H6.51395C5.90737 12.7266 5.41524 13.194 5.41524 13.757ZM10.8973 13.757C10.8973 14.32 11.4009 14.7767 12.0075 14.7767C12.6141 14.7767 13.1062 14.32 13.1062 13.7463C13.1062 13.194 12.6141 12.7372 12.0075 12.7266H11.996C11.3895 12.7372 10.8973 13.194 10.8973 13.757ZM17.4916 14.7778C16.885 14.7778 16.3929 14.3211 16.3929 13.7581C16.3929 13.1951 16.8736 12.7383 17.4916 12.7383C18.0982 12.7383 18.5903 13.1951 18.5903 13.7581C18.5903 14.3211 18.0982 14.7778 17.4916 14.7778ZM17.4896 19.1294C16.8831 19.1294 16.3909 18.6726 16.3795 18.1096C16.3795 17.5466 16.8716 17.0898 17.4782 17.0898H17.4896C18.0962 17.0898 18.5884 17.5466 18.5884 18.1096C18.5884 18.6726 18.0962 19.1294 17.4896 19.1294ZM12.0075 19.1322C11.4009 19.1322 10.8973 18.6754 10.8973 18.1124C10.8973 17.5494 11.3895 17.0927 11.996 17.082H12.0075C12.6141 17.0927 13.0947 17.5494 13.1062 18.1018C13.1062 18.6754 12.6141 19.1322 12.0075 19.1322ZM6.51409 19.1323C5.90751 19.1323 5.41538 18.6755 5.41538 18.1125C5.40393 17.5495 5.89606 17.0821 6.51409 17.0821C7.12067 17.0821 7.6128 17.5389 7.6128 18.1019C7.6128 18.6649 7.12067 19.1323 6.51409 19.1323Z" fill="#F83758" />
                                    </svg>
                                </button>
                                <span className='text-sm text-gray-500 ms-5'>
                                    {selected.date ? selected.date : "Choose from calender"}
                                </span>
                            </div>
                            {showDatePicker && (
                                <>
                                    <input
                                        type="date"
                                        value={selected.date}
                                        onChange={(e) => updateSelected("date", e.target.value)}
                                        className='w-11/12 p-3 border border-gray-300 rounded-sm ps-4' />
                                    <input
                                        type="time"
                                        value={selected.time}
                                        onChange={(e) => updateSelected("time", e.target.value)}
                                        className='w-11/12 p-3 mt-2 border border-gray-300 rounded-sm ps-4'
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                setShowDatePicker(false);
                                            }
                                        }} />

                                </>
                            )}
                        </div>
                        <div className='my-7'>
                            <p className='font-[600]'>City</p>
                            <div className="flex w-11/12 p-3 border border-gray-300 mt-7">
                                <button>
                                    <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect width="30.7895" height="30.7895" fill="white" />
                                        <path d="M21.75 14.5C21.75 19.75 15 24.25 15 24.25C15 24.25 8.25 19.75 8.25 14.5C8.25 12.7098 8.96116 10.9929 10.227 9.72703C11.4929 8.46116 13.2098 7.75 15 7.75C16.7902 7.75 18.5071 8.46116 19.773 9.72703C21.0388 10.9929 21.75 12.7098 21.75 14.5Z" stroke="#F83758" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M15 16.75C16.2426 16.75 17.25 15.7426 17.25 14.5C17.25 13.2574 16.2426 12.25 15 12.25C13.7574 12.25 12.75 13.2574 12.75 14.5C12.75 15.7426 13.7574 16.75 15 16.75Z" stroke="#F83758" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </button>
                                <Select
                                    style={{ width: '100%' }}
                                    placeholder="Select City"
                                    className="custom-select"
                                    value={selected.city}
                                    onChange={(value) => updateSelected("city", value)}
                                >
                                    {options.city?.map((item) => (
                                        <Option value={item.id}>{item.name},{item.state}</Option>
                                    ))}

                                </Select>
                            </div>
                        </div>
                        {/* Mode */}
                        <div className='my-7'>
                            <p className='font-[600]'>Mode</p>
                            <div className="flex w-11/12 p-3 mt-3 cursor-pointer">
                                <p onClick={() => updateSelected("mode", 'online')} className={`${selected.mode.includes('online') ? "bg-brandRed text-white me-2" : ''} p-2 px-3 mx-3 `}>Online</p>
                                <p onClick={() => updateSelected("mode", 'offline')} className={`${selected.mode.includes('offline') ? "bg-brandRed text-white" : ''} p-2 px-3`}>Offline</p>
                            </div>
                        </div>

                        {/* Select Price Range */}
                        <div className='w-11/12 my-7'>
                            <div className='flex justify-between'>
                                <p className='text-black text-[16px] font-normal'>Select Price Range</p>
                                <span className='text-[18px] font-normal text-pink-500'>{`₹${selected.price_from} - ₹${selected.price_to}`}</span>
                            </div>
                            <div className='flex flex-col justify-center mt-5'>
                                <div className='flex flex-col justify-center px-4'>
                                    <Slider
                                        range
                                        defaultValue={[selected.price_from, selected.price_to]}
                                        min={100}
                                        max={20000}
                                        onChange={(value) => {
                                            updateSelected('price_from', value[0])
                                            updateSelected('price_to', value[1])
                                        }}
                                        trackStyle={sliderStyle.trackStyle}
                                        dotStyle={sliderStyle.dotStyle}
                                        railStyle={sliderStyle.railStyle}
                                    />


                                </div>
                            </div>
                        </div>

                        {/*Actions */}
                        <div className='my-7'>
                            <div className="flex w-11/12 p-3 mt-3 cursor-pointer">
                                <p onClick={() => {
                                    setSelected({
                                        categories: [],
                                        tags: [],
                                        date: "",
                                        time: "",
                                        mode: [],
                                        city: "",
                                        relationship_status: [],
                                        price_from: '',
                                        price_to: '',
                                    });
                                }} className="p-2 px-3 mx-3 border-2 w-[150px] text-center">Cancel</p>
                                <p onClick={handleSubmit} className="p-2 px-3 w-[150px] text-center bg-brandRed text-white">Filter</p>
                            </div>
                        </div>
                    </div>

                    {/* EventCards */}
                    {events?.length > 0 ?
                        <div className="flex flex-wrap gap-4 h-fit">

                            {events?.map((item, index) => (
                                <div key={item?.id} className="w-full lg:w-[300px] max-h-[310px] my-3">
                                    <Link to={`/event/${item.slug}`} className="block h-full">
                                        <EventOverviewCard
                                            img={item.image}
                                            eventName={capitalize(item?.title)}
                                            fromToTime={`${formatDate(item.start_date)} ${convert24To12Hour(item.start_time)} to`}
                                            fromToDate={`${formatDate(item.end_date)} ${convert24To12Hour(item.end_time)}`}
                                            EventPrice={item.isFree ? true : item?.price}
                                        />
                                    </Link>
                                </div>
                            ))}
                        </div>
                        :
                        <div className="flex items-center justify-center w-full h-screen">
                            <Suspense children={<EmptyEvents mainText={"No Events"} subText={'You Have No Events Based on the Filter'} />} fallback={<div>loading...</div>} />
                        </div>
                    }

                </div>
            </div>
            {pagination.next_page &&
                <p className='w-full my-10 text-base text-center text-blue-500 cursor-pointer' onClick={handleSubmit}>see more</p>
            }
            <Suspense fallback={<div>Loading...</div>}>
                <div className="hidden w-full bg-black lg:block">
                    <Footer />
                </div>
                <div className="block mt-5 bg-black lg:hidden">
                    <ResponsiveFooter />
                </div>
            </Suspense>
        </div>
    )
}

export default Index




